/**
 * What the Conversations tab says about a practice conversation that is not
 * running (ST-20260923-0001).
 *
 * The first version only knew "not started", so a paused practice, one that
 * had run for fifteen turns, was described as never having begun and offered
 * "Start conversation". There are three different situations and each needs
 * its own words:
 *
 *   paused  - the therapist paused it (server pausedAt, or Pause pressed here)
 *   stopped - it has run but is not running now, without being paused
 *             (for example it reached the automatic turn limit)
 *   new     - only the synthetic client's opening line exists
 *
 * Kept pure so it can be tested without mounting ClientDetailView.
 */

// Therapist-side turns. Their presence means the conversation has run.
const THERAPIST_SIDE_ROLES = new Set(['ai', 'human_therapist']);

export function conversationHasRun(conversation) {
  const messages = Array.isArray(conversation?.messages) ? conversation.messages : [];
  return messages.some((m) => THERAPIST_SIDE_ROLES.has(m?.senderRole));
}

export function practicePrompt({ paused, hasRun }) {
  if (paused) {
    return {
      state: 'paused',
      message: 'This practice conversation is paused. Resume it to carry on where you left off.',
      buttonLabel: 'Resume conversation',
    };
  }
  if (hasRun) {
    return {
      state: 'stopped',
      message: 'This practice conversation has stopped. Resume it to carry on where you left off.',
      buttonLabel: 'Resume conversation',
    };
  }
  return {
    state: 'new',
    message: 'This practice conversation has not started yet. The synthetic client and the AI therapist will take turns once you start it.',
    buttonLabel: 'Start conversation',
  };
}
